// extracted by mini-css-extract-plugin
export default {"container":"T01_privacy_container__5LcDS","limiter":"T01_privacy_limiter__e1Cfg"};